export const parseNumber = (value) => Number(value) || 0;
